import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: relative;
`;

export const BasesWrapper = styled.div`
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  border: 1px solid #cbcbcb;
  border-radius: 5px;
  width: 365px;
  min-height: 50px;
  cursor: pointer;

  @media (max-width: 768px) {
    padding: 8px 9px;
    max-width: 172px;
    width: 172px;
    min-width: unset;
    justify-content: space-between;
    min-height: unset;
  }
`;

export const BaseText = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #636363;
`;

export const BaseIconWrapper = styled.div``;

export const BasesItemsContainer = styled.div`
  position: absolute;
  top: 58px;
  left: 0;
  width: 100%;
  background: #ffffff;
  border: 1px solid #cbcbcb;
  border-radius: 4px;
  z-index: 1;
  padding: 8px;
  height: 132px;
  overflow: auto;

  @media (max-width: 768px) {
    position: fixed;
    top: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
    background: #eff0f0;
    z-index: 9999;
    border-radius: unset;
    border: unset;
    padding: 12px;
    justify-content: flex-start;
  }
`;

export const BaseItemWrapper = styled.div`
  display: flex;
  gap: 8px;
  cursor: pointer;
  padding: 8px;
  border-bottom: 2px solid #e2e2e2;
`;

type SelectProps = {
  selected?: boolean;
};

export const FakeSelect = styled.div<SelectProps>`
  width: 18px;
  height: 18px;
  border: 2px solid #bdbdbd;
  border-radius: 4px;

  ${({ selected }) =>
    selected &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      background: #00995d;
    `}
`;

export const BaseItemText = styled.span`
  font-family: 'Mangueira Medium', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color: #636363;
`;

export const BasesSelectedWrapper = styled.div`
  height: 34px;
  width: inherit;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
`;

export const BaseSelectedItemWrapper = styled.div`
  display: flex;
  gap: 8px;
  border: 1px solid #0000003b;
  border-radius: 16px;
  width: fit-content;
  padding: 4px;
  align-items: center;
`;

export const BaseSelectedItemText = styled.span`
  display: inline-block;
  font-family: 'Mangueira', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: #000000de;
`;

export const BaseSelectedItemIconWrapper = styled.div`
  cursor: pointer;
`;

export const FilterBasesButtonConfirm = styled.div`
  border-radius: 8px;
  padding: 8px;
  cursor: pointer;
  font-family: 'Mangueira Medium', sans-serif;
  font-weight: 500;
  font-size: 15px;
  line-height: 21px;
  background: #0b29fb;
  color: #ffff;
  border: 1px solid #0b29fb;
`;

export const MobileTitleWrapper = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    margin-bottom: 16px;
  }
`;

export const MobileTitle = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #3d3d3d;
`;

export const CloseIcon = styled(MobileTitle)`
  cursor: pointer;
`;

export const FilterButtonWrapper = styled.div`
  display: none;
  @media (max-width: 768px) {
    margin-top: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
`;
